import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem("asc_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser({ club: data.club, role: data.role, label: data.label, is_impersonation: !!data.is_impersonation });
    } catch (e) {
      localStorage.removeItem("asc_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (clubSlug, accessCode) => {
    const { data } = await api.post("/auth/login", {
      club_slug: clubSlug,
      access_code: accessCode,
    });
    localStorage.setItem("asc_token", data.token);
    setUser({ club: data.club, role: data.role, label: data.label });
    return data;
  };

  const registerClub = async (payload) => {
    const { data } = await api.post("/clubs/register", payload);
    localStorage.setItem("asc_token", data.token);
    setUser({ club: data.club, role: data.role, label: "Président" });
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("asc_token");
    setUser(null);
  };

  const refreshClub = async () => {
    try {
      const { data } = await api.get("/clubs/me");
      setUser((u) => (u ? { ...u, club: data } : u));
    } catch (e) {}
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, registerClub, refreshClub }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
